<template>
  <div>
    <b-modal v-model="openRequestModal" :title="title" size="lg" @ok.prevent="attemptRequestSubmit = true"
      @cancel="editingAdminRequest = false">
      <admin-request-form v-model="attemptRequestSubmit" :adminRequest="editingAdminRequest ? selectedRequest : null"
        :totalPercent="adminPercent" :usedPercent="totalAdminPercent" v-on:complete="processAdminRequest"
        v-if="openRequestModal"></admin-request-form>
    </b-modal>

    <b-modal v-model="confirmDeletion" title="Confirm Delete" v-if="selectedRequest"
      @ok="removeAdminRequest(selectedRequest)" @cancel="clearAdminRequest()">
      Are you sure you want to delete this administrative time request?
      <div>
        {{ selectedRequest.notes }}
      </div>
    </b-modal>

    <table-widget :items="requests" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">
        <b-button v-if="editable" @click="openRequestAdd()" class="ml-2" variant="primary"><font-awesome-icon
            icon="plus" />Add Administrative Time
          Request</b-button>
      </template>

      <template slot="content">
        <!-- <b-alert :show="editable"><font-awesome-icon icon="exclamation-circle" /> Administrative time
          requests are not saved until you click the submit button
          below.</b-alert> -->
        <b-table striped :items="selectedRequests" :fields="fields" :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFiltered" small show-empty :tbody-transition-props="transProps"
          empty-filtered-text="There are no requests that match your search criteria.">
          <template v-slot:cell(createdDate)="data">
            <template v-if="data.item.createdDate">
              {{ data.item.createdDate | formatDateTime }}
            </template>

            <template v-else> Not Submitted </template>
          </template>

          <template v-slot:cell(percent)="data">
            {{ data.item.administrativePercent || 0 }}
          </template>

          <template v-slot:cell(status)="data">
            {{ data.item.currentStatus.statusName }}
          </template>

          <template v-slot:cell(supervisor)="data">
            {{ data.item.supervisor.fullName }}
          </template>

          <template v-slot:cell(courseReleases)="data">
            <span v-if="data.item.numberOfCourses">{{ data.item.numberOfCourses }} courses</span>
            <span v-else>None</span>
          </template>

          <template v-slot:cell(stipend)="data">
            {{ data.item.stipend | trueOrFalse }}
          </template>

          <template v-slot:cell(controls)="data">
            <div class="text-right" v-if="(data.item.currentStatus.statusName == 'Submitted' ||
              data.item.currentStatus.statusName == 'Not Submitted' || data.item.currentStatus.statusName == 'Resubmit') &&
              editable
            ">
              <font-awesome-icon icon="pencil-alt" class="edit-icon mx-1"
                @click="openRequestEdit(data.item)"></font-awesome-icon>
              <font-awesome-icon icon="times" class="remove-icon mx-1"
                @click="confirmRemoveRequest(data.item)"></font-awesome-icon>
            </div>
          </template>
          <!-- <template v-slot:custom-foot="data">
            <b-tr>
              <b-td>Total:</b-td>
              <b-td
                >{{ totalAdminPercent }}% used out of {{ adminPercent }}% total
                administrative percent.</b-td
              >
              <b-td></b-td>
              <b-td></b-td>
            </b-tr>
          </template> -->
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget"
import AdminRequestForm from "./admin-request-form.vue"
export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      items: [],
      fields: [
        { key: "status", sortable: true, label: "Status" },
        { key: "percent", sortable: true, label: "Percent" },
        { key: "supervisor", sortable: true, label: "Supervisor" },
        { key: "courseReleases", sortable: true, label: "Course Releases" },
        { key: "stipend", sortable: true, label: "Stipend" },
        { key: "notes", label: "Explanation of Duties" },
        { key: "createdDate", sortable: true, label: "Date" },
        { key: "controls", label: "" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedRequests: [],
      openRequestModal: false,
      editingAdminRequest: false,
      selectedRequest: null,
      attemptRequestSubmit: false,
      confirmDeletion: null
    }
  },

  props: {
    requests: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    adminPercent: {
      type: Number,
      required: false,
      default: function () {
        return 0
      }
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return "New Buyout Request"
      }
    },
    editable: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    }
  },

  components: {
    TableWidget,
    AdminRequestForm
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    openRequestAdd: function () {
      this.openRequestModal = true
    },

    processAdminRequest: function (adminRequest) {
      this.attemptRequestSubmit = false
      if (adminRequest) {
        if (this.editingAdminRequest) {
          this.$emit("edited", adminRequest)
        } else {
          this.$emit("added", adminRequest)
        }
        this.openRequestModal = false
      }
      this.editingAdminRequest = false
    },

    openRequestEdit: function (request) {
      this.selectedRequest = request
      this.editingAdminRequest = true
      this.openRequestModal = true
    },

    confirmRemoveRequest(request) {
      this.selectedRequest = request
      this.confirmDeletion = true
    },
    removeAdminRequest(request) {
      //this.buyouts.splice(index, 1);
      this.$emit("removed", request)
    },
    clearAdminRequest() {
      this.selectedRequest = null
    }
  },

  computed: {
    totalAdminPercent: function () {
      if (!this.requests) return 0
      return _.sumBy(this.requests, request => {
        if (
          request.currentStatus &&
          (request.currentStatus.statusName == "Submitted" ||
            request.currentStatus.statusName == "Approved")
        ) {
          return parseFloat(request.administrativePercent)
        }
        return 0
      })
    }
  },

  watch: {
    requests: function () {
      if (this.requests.length) {
        this.selectedRequests = this.requests
        this.totalRows = this.requests.length
      }
    }
  },

  created() {
    if (this.requests.length) {
      this.selectedRequests = this.requests
      this.totalRows = this.requests.length
    }
  }
}
</script>

<style scoped></style>
